import type { CreativeEntry } from 'types/shared';

const hasLocalizations = (locales: string[] | undefined): boolean =>
  Array.isArray(locales) && locales.length > 0;

export const isDloAdType = (adType: string | undefined): boolean =>
  adType?.toLowerCase() === 'dlo';

export const isCreativeSelectableForDlo = (
  creative: Pick<CreativeEntry, 'locales'>,
  adType: string | undefined,
): boolean => {
  if (!isDloAdType(adType)) {
    return true;
  }

  return hasLocalizations(creative.locales);
};

export const isCreativeRowSelectable = (
  creative: Pick<CreativeEntry, 'id' | 'locales'>,
  adType: string | undefined,
  selectedIds: readonly string[],
  limit: number,
): boolean => {
  if (!isCreativeSelectableForDlo(creative, adType)) {
    return false;
  }

  return selectedIds.length < limit || selectedIds.includes(creative.id);
};

export const countCreativesWithoutLocalizations = (
  creatives: readonly Pick<CreativeEntry, 'locales'>[] | undefined,
): number =>
  creatives?.filter((creative) => !hasLocalizations(creative.locales)).length ?? 0;

export const getDloNoLocalizationsHintMessage = (count: number): string =>
  `${count} ${count === 1 ? 'creative has' : 'creatives have'} no localizations for DLO`;
